/*export { default as List } from './List';*/
import asyncRoute from '../../lib/asyncRoute';

export const List = asyncRoute(() => import('./List'));